export enum EMCType {
    Pole = 0,
    DistributionSubstation = 1,
    MvPole = 2,
    InjectionSubstation = 3,
    HvPole = 4,
    TransmissionStation = 5,
    SecondaryFeeder = 6,
    MainFeeder = 7,
    Device = 8,
    Building = 9,
    Meter = 10,
    SubstationTemplate = 11,
    EquipmentTemplate = 12,
    NewCustomer = 13,
    NewMeterRequest = 14,
    MeterUpgrade = 15,
    MeterSeparationSplit = 16,
    DedicatedDistributionTransformerRequest = 17,
    DedicatedFeederRequest = 18,
    LVPoleExtension = 19,
    MVPoleExtension = 20,
    VoluntaryDisconnection = 21,
    PermanentDisconnection = 22,
    Customer = 23
}